type TokenAccessor = () => string | null;
let tokenAccessor: TokenAccessor | null = null;

export const registerTokenAccessor = (accessor: TokenAccessor): void => {
  tokenAccessor = accessor;
};

export const getTokenAccessor = (): string | null => {
  return tokenAccessor?.() || null;
};
